import { getControlItem, seekToTime } from '../utils/helpers'
import { Controls } from './controls'

export class ProgressBar extends Controls {
  constructor(element: HTMLElement, videoPlayer: HTMLVideoElement, wrapperElement: HTMLDivElement) {
    super(element, videoPlayer, wrapperElement)
    this.renderProgressBar()
  }

  private renderProgressBar() {
    this.controlBarSectionElement.appendChild(
      getControlItem({
        parent: {
          element: 'div',
          classes: ['cmp-video-wrapper__progress-bar'],
        },
        children: [
          { element: 'div', classes: ['cmp-video-wrapper__progress-bar--buffer'] },
          { element: 'div', classes: ['cmp-video-wrapper__progress-bar--progress'] },
          { element: 'span', classes: ['cmp-video-wrapper__progress-bar--current-time'] },
          { element: 'span', classes: ['cmp-video-wrapper__progress-bar--hover-time'] },
        ],
        eventListeners: ['click', 'mousemove'],
        callback: (event: MouseEvent) => {
          seekToTime({
            event,
            videoPlayer: this.videoPlayer,
            wrapperElement: this.wrapperElement,
            progressBarSelectorClass: 'cmp-video-wrapper__progress-bar',
          })
        },
      }),
    )
  }
}
